import app from 'app';
import ready from 'utils/ready';
import productBundle from './product-bundle/main';

app.add({
  productBundle,
});

ready(app.mount);
